import React from 'react';
import { inject, observer } from "mobx-react";
import { Variant } from "./variant";
import { doesContainFiles } from "../../../services/utils";
import { VariantsBulkEditor } from "./bulkEditor";
import { makeObservable } from "mobx";
import { Button, Card, Space, Typography, Collapse, Alert, Badge } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

@inject('currentItem')
@observer
export class VariantsMatrixSection extends React.Component {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    deleteVariant = (id) => {
        this.props.currentItem.deleteVariant(id);
        if (doesContainFiles(this.props.currentItem.type)) {
            this.props.currentItem.isReady = false;
        }
    }

    addVariant = () => {
        this.props.currentItem.constructVariant();
        if (doesContainFiles(this.props.currentItem.type)) {
            this.props.currentItem.isReady = false;
        }
    }

    countVariations = (variationsTypes) =>
        variationsTypes.reduce((acc, cur) => (acc || 1) * cur.variations.length, 0);

    getVariantTitle = (variant) => {
        const allVariations = this.props.currentItem.variationsTypes.flatMap(vt => vt.variations);
        const titles = (variant.variationsIds || [])
            .map(id => allVariations.find(v => v.id === id)?.title)
            .filter(Boolean);
        return titles.length > 0 ? titles.join(' · ') : null;
    }

    render() {
        const { currentItem } = this.props;
        const total = this.countVariations(currentItem.variationsTypes);

        const collapseItems = currentItem.variants.map((variant, i) => ({
            key: variant.id,
            label: (
                <Space>
                    <Typography.Text>{this.getVariantTitle(variant) ?? `Variant ${i + 1}`}</Typography.Text>
                    {!variant.availableInCatalog && (
                        <Typography.Text type="danger" style={{ fontSize: 12 }}>hidden</Typography.Text>
                    )}
                </Space>
            ),
            extra: (
                <Button
                    icon={<DeleteOutlined />}
                    size="small"
                    danger
                    type="text"
                    onClick={(e) => { e.stopPropagation(); this.deleteVariant(variant.id); }}
                />
            ),
            children: <Variant type={currentItem.type} variant={variant} />,
        }));

        const count = currentItem.variants.length;
        const noVariations = total === 0;
        const variantStatus = count >= total ? 'info' : 'warning';
        const variantMessage = `${count} / ${total} possible variants`;

        return (
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <Card size="small" title="Bulk">
                    <Space direction="vertical" size={8} style={{ width: '100%' }}>
                        <VariantsBulkEditor />
                        <Alert type={variantStatus} message={variantMessage} showIcon />
                    </Space>
                </Card>

                {collapseItems.length > 0 && (
                    <Collapse items={collapseItems} size="small" />
                )}

                <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    disabled={noVariations}
                    title={noVariations ? 'Add variations in the Variations Table tab first' : undefined}
                    onClick={this.addVariant}
                >
                    Add Variant
                </Button>
            </Space>
        );
    }
}
